import styled from 'styled-components';

export const DropDownDividerContainer = styled.div<{ color?: string }>`
  margin: 12px 0px;
  width: 100%;
  border-bottom: 1px solid ${({ color }) => color || 'rgba(0, 0, 0, 0.1)'};
`;
